import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getIndustrySectors, saveBatchIndustrySectors } from '../../api/industrySectors';
import type { IndustrySector } from '../../types/IndustrySector';
import { t } from '../../i18n/t';

const columnDefs: ColDef<IndustrySector>[] = [
  {
    field: 'industrySectorId',
    headerName: t('industrySectors.columns.industrySectorId'),
    width: 140,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<IndustrySector>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'industrySectorName', headerName: t('industrySectors.columns.industrySectorName'), flex: 1, editable: true },
];

const newRowDefaults = (): Partial<IndustrySector> => ({ industrySectorId: 0, industrySectorName: '' });

export function IndustrySectorsPage() {
  return (
    <LopCrudPage<IndustrySector>
      resourceCode="industrySectors"
      titleKey="industrySectors.pageTitle"
      idField="industrySectorId"
      getRows={getIndustrySectors}
      saveBatch={(added, modified, deletedIds) => saveBatchIndustrySectors(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
